import { ARTICLE_POLICY_VERSION, hasNoAdverseConduct } from './adverseMediaArticlePolicy';

export const ARTICLE_REVIEW_REASONS = {
  allegation: 'The article reports allegations against the subject. Review the supporting evidence and any reported outcome.',
  dismissed: 'The article reports a dismissal. Verify which allegations against the subject were dismissed and whether any remain unresolved.',
  acquitted: 'The article reports an acquittal. Verify which allegations against the subject it covers and whether any separate matters remain unresolved.',
  name: 'Confirm that the article refers to the screened individual, as the name match is uncertain.',
  sourceUnknown: 'Source reliability has not been established.',
  sourceLow: 'The source has a low reliability assessment. Corroborate the report.',
  involvement: 'The subject’s involvement is unclear.',
  incomplete: 'The available information is insufficient for a conclusive assessment.',
  rerun: 'Re-run screening to obtain a complete assessment.',
};

// Review is a separate workflow requirement, not a concern rating. Use only
// the saved subject-linked findings, never allegations mentioned in free text
// or findings belonging to other parties in the article.
export function articleReviewReasons(assessment, concern) {
  if (concern === 'unavailable' || concern === 'none') return [];
  if (assessment?.assessmentVersion !== ARTICLE_POLICY_VERSION) return [ARTICLE_REVIEW_REASONS.rerun];

  if (hasNoAdverseConduct(assessment)) return [];

  const reasons = new Set();
  const add = key => reasons.add(ARTICLE_REVIEW_REASONS[key]);
  const name = assessment.nameAssessment;
  if (!Number.isFinite(name?.score) || name.score <= 0 || !['strong', 'moderate'].includes(name.strength)) add('name');
  // Established contextual mentions do not inherit allegations about others.
  if (assessment.involvement === 'contextual') return [...reasons];

  const findings = assessment.findings || [];
  const direct = findings.filter(finding => finding.involvement === 'direct');
  for (const status of ['allegation', 'dismissed', 'acquitted']) {
    if (direct.some(finding => finding.caseStatus === status)) add(status);
  }
  if (assessment.involvement !== 'direct'
    || findings.some(finding => !['direct', 'contextual'].includes(finding.involvement))) add('involvement');
  if (direct.length) {
    if (assessment.sourceQuality === 'low') add('sourceLow');
    else if (!['high', 'medium'].includes(assessment.sourceQuality)) add('sourceUnknown');
    if (direct.some(finding => !['low', 'medium', 'high'].includes(finding.severity))) add('incomplete');
  }
  if (!findings.length || (concern === 'review' && !reasons.size)) add('incomplete');
  return [...reasons];
}
